import { css } from 'styled-system/css';

export const BetModeControlStyle = {
	quickbetSwitch: css({
	}),
	leftSwitch: css({
		'--galaxy-content-bg': { base: 'var(--lv2-100)', _dark: 'var(--s600)' },
		base: {
			visibility: 'hidden',
			_active: {
				visibility: 'visible',
				bgColor: 'var(--background-neutral-100-300, var(--galaxy-content-bg))',
			},
			'& .icon': {
				color: 'var(--background-component-quickbet-default, var(--quickbet))' 
			}
		}
	}),
	rightSwitch: css({
		'--galaxy-content-bg': { base: 'var(--lv2-100)', _dark: 'var(--s600)' },
		visibility: 'hidden',
		base: {
			_active: {
				visibility: 'visible',
				bgColor: 'var(--background-component-quickbet-default, var(--quickbet))'
			},
			'& .icon': {
				color: 'var(--text-neutral-400-500, var(--galaxy-content-bg))',
			}
		}
	}),
}